// extracted by mini-css-extract-plugin
export default {"container":"container---uxhmL","firstRow":"firstRow---Yy4iy","secondRow":"secondRow---yjkcm"};